export const NotificationBar = () => {

  return (
    <div className="flex flex-wrap justify-start items-center">
      {/** Pendiente */}
    </div>
  );
};
